let ALL = {
	SanTai: [
		{
			label: 'SFC Global Line-no battery',
			value: 'SFC Global Line-no battery',
		},
		{
			label: 'SFC Global Line-with battery',
			value: 'SFC Global Line-with battery',
		},
	],
	YanWen: [
		{
			label: '燕文航空挂号小包-普货',
			value: 'Yanwen Air Register Mail General',
		},
		{
			label: '燕文航空挂号小包-特货',
			value: 'Yanwen Air Register Mail Special',
		},
		{
			label: '燕邮宝挂号-特货',
			value: 'Y-POST REGISTERED MAIL-T',
		},
		{
			label: '燕文英国快线平邮-普货',
			value: 'UK Direct Line Priority Untracted Packet-T',
		},
		{
			label: '燕文专线平邮小包-普货',
			value: 'Yanwen Air Untrack Packet General',
		},
		{
			label: '燕文专线平邮小包-特货',
			value: 'Yanwen Air Untrack Packet Special',
		},
		{
			label: '燕文航空经济小包-普货',
			value: 'Yanwen Air Economy Mail General',
		},
		{
			label: '燕文航空经济小包-特货',
			value: 'Yanwen Air Economy Mail Special',
		},
		{
			label: '燕邮宝平邮-特货',
			value: 'Yanwen Y-P ECONOMIC MAIL-T',
		},
		{
			label: '燕文英国RM快线-普货',
			value: 'Yanwen Direct Line Priority Packet-P',
		},
		{
			label: '燕文英国RM快线-特货',
			value: 'Yanwen Direct Line Priority Packet-T',
		},
		{
			label: '燕文英国YODEL快线-普货',
			value: 'Yanwen YODEL-Small packet',
		},
		{
			label: '燕文专线快递-普货',
			value: 'Yanwen Direct Line Express General',
		},
		{
			label: '燕文专线快递-特货',
			value: 'Yanwen Direct Line Express Special',
		},
		{
			label: '燕文专线追踪小包-普货',
			value: 'Yanwen Air Track Packet General',
		},
		{
			label: '燕文专线追踪小包-特货',
			value: 'Yanwen Air Track Packet Special',
		},
		{
			label: '燕文英国HERMES快线-普货',
			value: 'Yanwen Hermes Direct Line Priority Packet-P',
		},
		{
			label: '燕文法国快线-普货',
			value: 'Yanwen FR Direct Line Priority Packet-P',
		},
		{
			label: '燕文德国快线-普货',
			value: 'Yanwen DE Direct Line Priority Packet-P',
		},
		{
			label: '燕文专线惠选-普货',
			value: 'Yanwen Special Offer Tracked Packet-P',
		},
		{
			label: 'DDP燕文专线追踪-普货',
			value: 'Yanwen DDP Direct Line Tracked Packet-P',
		},
		{
			label: 'DDP燕文专线追踪-特货',
			value: 'Yanwen DDP Direct Line Tracked Packet-T',
		},
	],
	DiSiFang: [
		{
			label: '4PX全球速递标准-带电',
			value: '4PX-Global Express',
		},
		{
			label: '联邮通优先挂号-带电',
			value: '4PX-PostLink priority Registered Mail-Li',
		},
		{
			label: '联邮通标准挂号-带电',
			value: '4PX-PostLink Standard Registered Mail-Li',
		},
		{
			label: '联邮通标准2挂号-带电',
			value: '4PX-PostLink Standard2 Registered Mail-Li',
		},
		{
			label: '联邮通经济2挂号-带电',
			value: '4PX-PostLink Economy2 Registered Mail-Li',
		},
		{
			label: '联邮通经济挂号-带电',
			value: '4PX-PostLink Economy Registered Mail-Li',
		},
		{
			label: '联邮通经济SRM-带电',
			value: '4PX-PostLink Economy SRM Registered Mail-Li',
		},
		{
			label: '联邮通标准平邮-带电',
			value: '4PX-PostLink Standard Ordinary Mail-Li',
		},
		{
			label: '联邮通标准large letter-带电',
			value: '4PX-PostLink Standard large letter Ordinary Mail-Li',
		},
		{
			label: '联邮通经济large letter-带电',
			value: '4PX-PostLink Economy large letter Ordinary Mail-Li',
		},
		{
			label: '联邮通优先挂号-普货',
			value: '4PX-PostLink priority Registered Mail-NOLi',
		},
		{
			label: '联邮通标准挂号-普货',
			value: '4PX-PostLink Standard Registered Mail-NOLi',
		},
		{
			label: '4PX-联邮通经济挂号-普货',
			value: '4PX-PostLink Economy Registered Mail-NOLi',
		},
	],
	YunTu: [
		{
			label: '云途全球专线挂号(标快)',
			value: 'YunExpress Global Direct line (standard)-Tracked',
		},
		{
			label: '云途全球专线挂号(特惠带电)',
			value: 'YunExpress Global Direct line with Battery-Tracked',
		},
		{
			label: '云途全球专线挂号(特惠普货)',
			value: 'YunExpress Global Direct line non Battery-Tracked',
		},
		{
			label: '云途全球专线平邮(标快)',
			value: 'YunExpress Global line (standard)-Untracked',
		},
		{
			label: '云途全球专线平邮(特惠带电)',
			value: 'YunExpress Global Direct line-with battery-Untracked',
		},
		{
			label: '云途全球专线平邮(特惠普货)',
			value: 'YunExpress Global Direct line-non battery-Untracked',
		},
		{
			label: '日本专线挂号',
			value: 'YunExpress JP Direct Line',
		},
		{
			label: '德国专线简易挂号',
			value: 'YunExpress DE SRM Direct Line',
		},
		{
			label: '中东专线',
			value: 'YunExpress ME Direct Line',
		},
		{
			label: '云途亚马逊专线DDP',
			value: 'YunExpress ME Direct Line-DDP',
		},
		{
			label: 'EUB',
			value: 'E-packet',
		},
	],
	UPS: [
		{
			label: 'UPS 2nd Day Air',
			value: 'UPS 2nd Day Air',
		},
		{
			label: 'UPS 3 Day Select',
			value: 'UPS 3 Day Select',
		},
		{
			label: 'UPS Ground',
			value: 'UPS Ground',
		},
		{
			label: 'UPS i-parcel lnternational Select',
			value: 'UPS i-parcel lnternational Select',
		},
		{
			label: 'UPS Next Day Air',
			value: 'UPS Next Day Air',
		},
		{
			label: 'UPS Next Day Air Saver',
			value: 'UPS Next Day Air Saver',
		},
	],
	DHL: [
		{
			label: 'DHL Express',
			value: 'DHL Express',
		},
		{
			label: 'International Mail',
			value: 'International Mail',
		},
		{
			label: 'Parcel',
			value: 'Parcel',
		},
	],
	DPD: [
		{
			label: 'DPD Classic',
			value: 'DPD Classic',
		},
		{
			label: 'DPD Express',
			value: 'DPD Express',
		},
		{
			label: 'Parcel Next Day',
			value: 'Parcel Next Day',
		},
		{
			label: 'Parcel Saturday',
			value: 'Parcel Saturday',
		},
		{
			label: 'ExpressPak Next Day',
			value: 'ExpressPak Next Day',
		},
		{
			label: 'ExpressPak Saturday',
			value: 'ExpressPak Saturday',
		},
	],
	GLS: [
		{
			label: 'Parcel',
			value: 'Parcel',
		},
	],
	FedEx: [],
	other: [],
	JieAn: [
		{
			label: 'USPS Bound Printed Matter',
			value: 'USPS Bound Printed Matter',
		},
		{
			label: 'USPS First Class',
			value: 'USPS First Class',
		},
		{
			label: 'USPS First Class International',
			value: 'USPS First Class International',
		},
		{
			label: 'USPS First Class Mail Envelopes',
			value: 'USPS First Class Mail Envelopes',
		},
		{
			label: 'USPS Media Mail',
			value: 'USPS Media Mail',
		},
		{
			label: 'USPS Parcel Post',
			value: 'USPS Parcel Post',
		},
		{
			label: 'USPS Parcel Select',
			value: 'USPS Parcel Select',
		},
		{
			label: 'USPS Priority Mail',
			value: 'USPS Priority Mail',
		},
		{
			label: 'USPS Priority Mail Cubic',
			value: 'USPS Priority Mail Cubic',
		},
		{
			label: 'USPS Priority Mail Express',
			value: 'USPS Priority Mail Express',
		},
		{
			label: 'USPS Priority Mail Express International',
			value: 'USPS Priority Mail Express International',
		},
		{
			label: 'USPS Priority Mail International',
			value: 'USPS Priority Mail International',
		},
		{
			label: 'USPS Standard Mail Envelopes',
			value: 'USPS Standard Mail Envelopes',
		},
		{
			label: 'other',
			value: 'other',
		},
	]
}
export { ALL }
